import { useState, useCallback } from "react";

export default function Search({ setSearch, setPage }) {
  const [inputValue, setInputValue] = useState("");
  const [error, setError] = useState("");

  const handleSearch = useCallback(() => {
    const value = inputValue.trim();
    
    // Clear search if input is empty
    if (value === "") {
      setSearch("");
      setError("");
      return;
    }
    
    // Validate minimum length
    if (value.length < 3) {
      setError("Enter at least 3 characters");
      return;
    }
    
    setError("");
    setSearch(value);
    setPage(1);
  }, [inputValue, setSearch, setPage]);

  const handleKeyPress = useCallback((e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  }, [handleSearch]);

  const handleClear = useCallback(() => {
    setInputValue("");
    setError("");
    setSearch(""); // This triggers Main.jsx to clear data
    setPage(1); // Reset to page 1
  }, [setSearch, setPage]);

  return (
    <div className="flex flex-col gap-2">
      <div className="flex gap-2">
        <input
          type="text"
          className="bg-gray-50 border-2 border-orange-400 h-10 px-4 rounded-lg text-sm flex-1
                  focus:outline-none focus:shadow focus:bg-white"
          placeholder="Search by ID or Name (min 3 chars)..."
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onKeyPress={handleKeyPress}
        />
        <button
          type="button"
          onClick={handleSearch}
          className="bg-orange-500 hover:bg-orange-600 text-white px-6 py-2 rounded-lg text-sm font-medium
                     transition-colors duration-200"
        >
          Search
        </button>
        {inputValue && (
          <button
            type="button"
            onClick={handleClear}
            className="bg-gray-500 hover:bg-gray-600 text-white px-4 py-2 rounded-lg text-sm
                       transition-colors duration-200"
          >
            Clear
          </button>
        )}
      </div>
      {error && <p className="text-red-500 text-sm text-center">{error}</p>}
    </div>
  );
}
